import { type Observable, ApolloLink, type FetchResult } from "@apollo/client";
import { addBreadcrumb } from "@sentry/react";

import { updateShouldFrontendRefresh } from "./shouldFrontendRefresh.store";
type FetchResultWithShouldFrontendRefresh = FetchResult<Record<string, any>, Record<string, any>>;

/**
 * Apollo link that listens for calls from the backend to force refresh the frontend on next page navigation
 * If the backend responds with shouldFrontendRefresh `true`, we set a global variable to signal other parts of the codebase to refresh on the next navigation
 */
const getShouldFrontendRefreshLink = () => {
  return new ApolloLink((operation, forward) => {
    return (forward(operation) as Observable<FetchResultWithShouldFrontendRefresh>).map(result => {
      const shouldFrontendRefresh = result?.extensions?.shouldFrontendRefresh ?? false;
      updateShouldFrontendRefresh(shouldFrontendRefresh);

      if (shouldFrontendRefresh) {
        addBreadcrumb({
          category: "shouldFrontendRefresh",
          data: {
            shouldFrontendRefresh,
          },
          level: "info",
        });
      }

      return result;
    });
  });
};

export { getShouldFrontendRefreshLink };
